//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            accounts: [],
            balances: [],
            loading: true,
            glaccounts: [],
            selectedGlAccount: null,
            selectedBankAccount: null,
            glLoading: false,
            isLoading: false,
            addManual: false,
            selectedCheckWriting: false,
            manual: {
                name: null,
                bank: null,
                account: null
            },
            validations: [{ model: 'manual.name', rules: 'required' }, { model: 'manual.bank', rules: 'required' }, { model: 'manual.account', rules: 'required' }],
            allowedAdminUserRoles: ['super-admin', 'corporate-admin', 'accounting-admin']
        };
    },


    props: {
        autoload: {
            required: false,
            default: false,
            type: Boolean
        }
    },

    mounted: function mounted() {
        SelectedProperty = 1;

        if (this.autoload) {
            this.load();
        }
        this.$initValidator();
    },
    created: function created() {
        var _this = this;

        Event.$on('refresh-bank-accounts', function () {
            _this.load();
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('refresh-bank-accounts');
    },


    methods: {
        saveManual: function saveManual() {
            var _this2 = this;

            this.validator.setRules(this.validations).validate();
            if (this.validator.fails()) {
                return;
            }
            this.isLoading = true;
            axios.post('/prototype/accounting/bank-accounts', this.manual).then(function () {
                _this2.isLoading = false;
                _this2.manual = {};
                _this2.addManual = false;
                Event.$emit('refresh-bank-accounts');
            });
        },
        addgl: function addgl(account) {
            var $el = this;
            $el.selectedBankAccount = account;
            $el.selectedCheckWriting = account.check_writing == 1;
            if (this.glaccounts.length === 0) {
                axios.post('/prototype/accounting/general-ledger/accounts/fetch').then(function (response) {
                    $el.glaccounts = response.data;
                });
            }
            //Event.$emit('show-small-modal', 'Set G/L Account')
            this.$children[3].showSmallModal = true;
        },
        updategl: function updategl() {
            var _this3 = this;

            this.glLoading = true;
            axios.put('/prototype/accounting/bank-accounts/' + this.selectedBankAccount.id, { account_id: this.selectedGlAccount ? this.selectedGlAccount.id : 0, check_writing: this.selectedCheckWriting }).then(function (response) {
                _this3.selectedBankAccount = null;
                _this3.selectedGlAccount = null;
                _this3.selectedCheckWriting = false;
                _this3.glLoading = false;
                Event.$emit('close-small-modal');
                Event.$emit('refresh-bank-accounts');
            });
        },
        load: function load() {
            var $el = this;
            $el.loading = true;
            axios.get('/prototype/accounting/check-writing-bank-accounts').then(function (response) {
                $el.accounts = response.data;
            }).then(function () {
                $el.accounts.forEach(function (account) {
                    if (account.account_id != 0) {
                        axios.post('/prototype/accounting/bank-accounts/balance', { account: account.account_id, token: account.access_token }).then(function (response) {
                            response.data.accounts.map(function (account, idx) {
                                $el.balances.push(account.balances);
                            });
                        });
                    }
                });
                $el.loading = false;
            });
        },
        balance: function balance(id) {
            if (this.balances.length > 0) {
                return this.balances[id];
            }
        },
        details: function details(account) {
            // only for Plaid accounts
            if (account.account_id != 0) {
                Event.$emit('show-bank-transactions', account);
            } else {
                Event.$emit('edit-manual-account', account);
            }
        },
        canUserAddManualBank: function canUserAddManualBank() {
            return this.allowedAdminUserRoles.includes(window.validator.role());
        }
    },

    computed: {
        canPostTo: function canPostTo() {
            return this.glaccounts.filter(function (account) {
                return account.can_post_to === 1;
            });
        },
        accountNames: function accountNames() {
            return this.canPostTo.map(function (account) {
                return { id: account.id, label: account.number + ' - ' + account.name };
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/banking/BankAccountList.vue
// module id = HMrK
// module chunks = 0 1